const style = {
  statusPill: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    border: '1px solid #b6c2cf',
    borderRadius: 4,
    padding: '4px 8px',
    fontSize: 12,
    color: '#273444',
    backgroundColor: '#f5f7fa',
  },
  detailScroll: {
    height: 'calc(100vh - 295px)',
    overflowY: 'auto',
    paddingRight: 4,
  },
  organizationTabRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    marginBottom: 12,
  },
  organizationTabButton: {
    border: '1px solid #c7d2df',
    borderRadius: 4,
    padding: '6px 12px',
    backgroundColor: '#f7f9fc',
    color: '#445468',
    fontSize: 12,
    fontWeight: 'bold',
    cursor: 'pointer',
  },
  organizationTabButtonActive: {
    border: '1px solid #6f8fb3',
    borderRadius: 4,
    padding: '6px 12px',
    backgroundColor: '#eaf3ff',
    color: '#17324d',
    fontSize: 12,
    fontWeight: 'bold',
    cursor: 'pointer',
  },
  billingContext: {
    border: '1px solid #d7dde5',
    borderRadius: 4,
    backgroundColor: '#fff',
    marginTop: 12,
  },
  billingHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 10,
    padding: 10,
    borderBottom: '1px solid #d7dde5',
    backgroundColor: '#fbfcfd',
  },
  billingTitle: {
    fontSize: 14,
    fontWeight: 'bold',
  },
  workflowActions: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: 8,
    padding: 10,
    borderBottom: '1px solid #d7dde5',
  },
  disabledActionButton: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    border: '1px solid #b6c2cf',
    borderRadius: 4,
    padding: '5px 10px',
    fontSize: 12,
    color: '#5c6773',
    backgroundColor: '#eef2f6',
    cursor: 'not-allowed',
  },
  actionButton: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    border: '1px solid #6f8fb3',
    borderRadius: 4,
    padding: '5px 10px',
    fontSize: 12,
    color: '#17324d',
    backgroundColor: '#f2f8ff',
    cursor: 'pointer',
  },
  inlineActions: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
  },
  draftActionGroup: {
    display: 'flex',
    alignItems: 'end',
    flexWrap: 'wrap',
    gap: 8,
  },
  draftDateField: {
    display: 'grid',
    gap: 4,
    minWidth: 150,
  },
  iconActionButton: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '1px solid #b6c2cf',
    borderRadius: 4,
    width: 28,
    height: 28,
    color: '#17324d',
    backgroundColor: '#fff',
    cursor: 'pointer',
  },
  iconDisabledActionButton: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '1px solid #d7dde5',
    borderRadius: 4,
    width: 28,
    height: 28,
    color: '#8a94a3',
    backgroundColor: '#eef2f6',
    cursor: 'not-allowed',
  },
  quickBooksPanel: {
    borderBottom: '1px solid #d7dde5',
  },
  statusGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
    gap: 8,
    padding: 10,
  },
  billingSummaryGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
    gap: 8,
    padding: 10,
  },
  statusCell: {
    border: '1px solid #d7dde5',
    borderRadius: 4,
    padding: 8,
    backgroundColor: '#fff',
  },
  statusLabel: {
    fontSize: 11,
    color: '#5c6773',
    marginBottom: 4,
  },
  statusValue: {
    fontSize: 12,
    fontWeight: 'bold',
    color: '#17212b',
    wordBreak: 'break-word',
  },
  setupList: {
    display: 'grid',
    gap: 5,
    padding: '0 10px 10px',
    fontSize: 12,
    color: '#273444',
  },
  warningText: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    color: '#8a4b00',
  },
  actionMessage: {
    padding: '0 10px 10px',
    fontSize: 12,
    color: '#5c6773',
  },
  mappingGateNote: {
    margin: '0 10px 10px',
    padding: '8px 10px',
    border: '1px solid #d7dde5',
    borderRadius: 4,
    backgroundColor: '#fbfcfd',
    color: '#445468',
    fontSize: 12,
    lineHeight: 1.5,
  },
  onboardingPanel: {
    margin: 10,
    border: '1px solid #d7dde5',
    borderRadius: 4,
    backgroundColor: '#fbfcfd',
  },
  onboardingHeader: {
    display: 'grid',
    gap: 4,
    padding: 10,
    borderBottom: '1px solid #d7dde5',
  },
  onboardingSteps: {
    display: 'grid',
    gap: 8,
    padding: 10,
  },
  onboardingStep: {
    display: 'grid',
    gridTemplateColumns: '28px minmax(0, 1fr)',
    gap: 10,
    alignItems: 'start',
  },
  onboardingStepNumber: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 28,
    height: 28,
    borderRadius: 999,
    backgroundColor: '#eaf3ff',
    color: '#17324d',
    fontSize: 12,
    fontWeight: 'bold',
  },
  onboardingStepBody: {
    display: 'grid',
    gap: 4,
    minWidth: 0,
  },
  onboardingStepTitle: {
    fontSize: 12,
    fontWeight: 'bold',
    color: '#17212b',
  },
  onboardingHint: {
    padding: '0 10px 10px',
    fontSize: 12,
    color: '#5c6773',
  },
  onboardingSuccess: {
    padding: '0 10px 10px',
    fontSize: 12,
    color: '#17324d',
  },
  auditTrailNote: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    marginTop: 4,
    fontSize: 12,
    color: '#5c6773',
  },
  auditMeta: {
    marginTop: 6,
    fontSize: 11,
    color: '#5c6773',
    lineHeight: 1.4,
  },
  billingGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: 10,
    padding: 10,
  },
  toolbar: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: 8,
    padding: 10,
    borderBottom: '1px solid #d7dde5',
    backgroundColor: '#fbfcfd',
  },
  toolbarInput: {
    minWidth: 220,
    border: '1px solid #b6c2cf',
    borderRadius: 4,
    padding: '5px 8px',
    fontSize: 12,
  },
  toolbarSelect: {
    border: '1px solid #b6c2cf',
    borderRadius: 4,
    padding: '5px 8px',
    fontSize: 12,
    backgroundColor: '#fff',
  },
  relationPanel: {
    position: 'relative',
    border: '1px solid #d7dde5',
    borderRadius: 4,
    marginTop: 10,
    minWidth: 0,
  },
  mappingLoadingOverlay: {
    position: 'absolute',
    inset: 0,
    zIndex: 2,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 16,
    backgroundColor: 'rgba(255, 255, 255, 0.82)',
    backdropFilter: 'blur(1px)',
  },
  mappingLoadingCard: {
    display: 'grid',
    gap: 8,
    justifyItems: 'center',
    minWidth: 280,
    maxWidth: 420,
    padding: '18px 20px',
    border: '1px solid #d7dde5',
    borderRadius: 8,
    backgroundColor: '#ffffff',
    boxShadow: '0 10px 24px rgba(23, 50, 77, 0.12)',
    color: '#17324d',
    textAlign: 'center',
  },
  mappingLoadingTitle: {
    fontSize: 13,
    fontWeight: 'bold',
    color: '#17212b',
  },
  mappingLoadingBody: {
    fontSize: 12,
    color: '#5c6773',
    lineHeight: 1.5,
  },
  taxExemptionLayout: {
    display: 'grid',
    gridTemplateColumns: 'minmax(0, 1.3fr) minmax(320px, 1fr)',
    gap: 10,
    padding: 10,
  },
  selectedTableRow: {
    backgroundColor: '#eef6ff',
  },
  relationHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 8,
    padding: 8,
    borderBottom: '1px solid #d7dde5',
    backgroundColor: '#fbfcfd',
  },
  relationTitle: {
    fontSize: 12,
    fontWeight: 'bold',
  },
  contextNote: {
    fontSize: 12,
    color: '#5c6773',
  },
  tableWrap: {
    overflowX: 'auto',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    fontSize: 12,
  },
  th: {
    textAlign: 'left',
    padding: '9px 10px',
    borderBottom: '1px solid #d7dde5',
    backgroundColor: '#f5f7fa',
    color: '#344054',
    whiteSpace: 'nowrap',
  },
  td: {
    padding: '9px 10px',
    borderBottom: '1px solid #eef1f5',
    color: '#273444',
  },
  emptyState: {
    display: 'flex',
    minHeight: 220,
    alignItems: 'center',
    justifyContent: 'center',
    color: '#5c6773',
    fontSize: 13,
  },
  allocationSummaryGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(130px, 1fr))',
    gap: 8,
    padding: 10,
    borderBottom: '1px solid #d7dde5',
  },
  followUpSummaryGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))',
    gap: 8,
    padding: 10,
    borderBottom: '1px solid #d7dde5',
  },
  paymentStatusGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))',
    gap: 8,
    padding: 10,
    borderBottom: '1px solid #d7dde5',
  },
  reportingSummaryGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))',
    gap: 8,
    padding: 10,
    borderBottom: '1px solid #d7dde5',
  },
  reportingGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: 10,
    padding: 10,
  },
  paymentHelpText: {
    padding: '10px 10px 0',
    fontSize: 12,
    color: '#5c6773',
  },
  paymentEventList: {
    display: 'grid',
    gap: 10,
    padding: 10,
  },
  paymentEventRow: {
    display: 'grid',
    gridTemplateColumns: '120px 1fr',
    gap: 10,
    padding: 10,
    border: '1px solid #d7dde5',
    borderRadius: 4,
    backgroundColor: '#fbfcfd',
  },
  paymentEventDate: {
    fontSize: 12,
    fontWeight: 'bold',
    color: '#17212b',
  },
  paymentEventBody: {
    display: 'grid',
    gap: 6,
    minWidth: 0,
  },
  paymentEventHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 8,
    flexWrap: 'wrap',
  },
  paymentEventType: {
    fontSize: 12,
    fontWeight: 'bold',
    color: '#17212b',
  },
  paymentEventAmount: {
    fontSize: 12,
    fontWeight: 'bold',
    color: '#17324d',
  },
  paymentEventMeta: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 10,
    fontSize: 12,
    color: '#5c6773',
  },
  paymentEventNote: {
    fontSize: 12,
    color: '#273444',
    wordBreak: 'break-word',
  },
  followUpLinks: {
    display: 'grid',
    gap: 4,
  },
  linkActionButton: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    border: '1px solid #b6c2cf',
    borderRadius: 4,
    padding: '4px 8px',
    fontSize: 12,
    color: '#17324d',
    backgroundColor: '#fff',
    cursor: 'pointer',
    width: 'fit-content',
  },
  subtleText: {
    fontSize: 11,
    color: '#5c6773',
  },
  warningBanner: {
    margin: '0 10px 10px',
    padding: '8px 10px',
    border: '1px solid #f3c97a',
    borderRadius: 4,
    backgroundColor: '#fff7e6',
    color: '#8a4b00',
    fontSize: 12,
  },
  warningStack: {
    display: 'grid',
    gap: 8,
    padding: '10px 10px 0',
  },
  warningCard: {
    border: '1px solid #f3c97a',
    borderRadius: 4,
    backgroundColor: '#fffaf0',
    padding: 10,
    display: 'grid',
    gap: 6,
  },
  warningCardError: {
    borderColor: '#e29b8f',
    backgroundColor: '#fff3f1',
  },
  warningHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    fontSize: 12,
    fontWeight: 'bold',
    color: '#6a2d1f',
  },
  warningBody: {
    fontSize: 12,
    color: '#5c6773',
    lineHeight: 1.5,
  },
  warningMetaList: {
    display: 'grid',
    gap: 4,
    fontSize: 11,
    color: '#5c6773',
  },
  workspaceActions: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 8,
    flexWrap: 'wrap',
  },
  allocationEditorBody: {
    display: 'grid',
    gap: 10,
    padding: 10,
  },
  allocationRow: {
    display: 'grid',
    gridTemplateColumns: 'minmax(160px, 1.2fr) minmax(160px, 1.2fr) minmax(90px, 0.7fr) minmax(110px, 0.8fr) minmax(120px, 0.8fr) minmax(180px, 1fr) auto',
    gap: 8,
    alignItems: 'end',
    border: '1px solid #d7dde5',
    borderRadius: 4,
    padding: 10,
    backgroundColor: '#fbfcfd',
  },
  formField: {
    display: 'grid',
    gap: 4,
    minWidth: 0,
  },
  formFieldSmall: {
    display: 'grid',
    gap: 4,
    minWidth: 90,
  },
  taxExemptionDetailGrid: {
    display: 'grid',
    gridTemplateColumns: 'minmax(160px, 1fr) minmax(130px, 0.7fr) minmax(130px, 0.7fr)',
    gap: 10,
    padding: 10,
    borderBottom: '1px solid #d7dde5',
  },
  taxExemptionNoteGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: 10,
    padding: 10,
  },
  taxExemptionNoteCard: {
    border: '1px solid #d7dde5',
    borderRadius: 4,
    backgroundColor: '#fbfcfd',
    padding: 10,
    display: 'grid',
    gap: 6,
  },
  taxExemptionNoteText: {
    fontSize: 12,
    color: '#273444',
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
  },
  taxExemptionAuditList: {
    display: 'grid',
    gap: 10,
    padding: 10,
  },
  taxExemptionAuditRow: {
    border: '1px solid #d7dde5',
    borderRadius: 4,
    backgroundColor: '#fbfcfd',
    padding: 10,
    display: 'grid',
    gap: 6,
  },
  taxExemptionAuditMeta: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 10,
    fontSize: 12,
    color: '#5c6773',
  },
  fieldLabel: {
    fontSize: 11,
    color: '#5c6773',
    fontWeight: 'bold',
  },
  allocationActions: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    paddingBottom: 2,
  },
};

export default style;
